import { Theme } from '@mui/material';

import { paletteBase } from '@abg/kit-base';

import { LoginFormBodyStyling } from './types';

export const loginFormBodyStyling: LoginFormBodyStyling = {
  wrapper: {
    zIndex: 1400,
    '& .MuiDialog-container': {
      '& .MuiPaper-root': {
        width: { xs: '100%', sm: '450px' },
      },
    },
    '&.MuiBox-root': {
      width: { xs: '100%', sm: '450px' },
      background: paletteBase.white100,
      margin: '0 auto',
    },
  },
  divider: {
    margin: '0 0 24px 0',
  },
  head: {
    wrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '24px',
    },
    title: (theme: Theme) => ({
      padding: 0,
      fontFamily: theme.typography.fontFamily,
      textTransform: 'none',
      fontWeight: 700,
      fontSize: { xs: '18px', sm: '20px' },
      lineHeight: { xs: '26px', sm: '28px' },
      flex: 'auto',
    }),
    dialogActions: {
      paddingRight: 0,
    },
    closeIcon: {
      padding: 0,
      fontSize: '16px',
      cursor: 'pointer',
      path: {
        strokeWidth: '1.5px',
      },
    },
  },
  content: {
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      padding: '24px',
      rowGap: {
        xs: 2.5,
        sm: 3,
      },
    },
    banner: {
      wrapper: {
        padding: '13px 8px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        backgroundColor: paletteBase.black,
      },
      icon: {
        fontSize: '16px',
      },
      text: {
        fontSize: '12px',
        lineHeight: '16px',
        color: paletteBase.white100,
      },
    },
    dividerText: {
      lineHeight: '20px',
    },
    signUpBtn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textDecoration: 'none',
      width: '100%',
      minHeight: '40px',
      fontWeight: 500,
      color: paletteBase.black,
    },
  },
};
